import { render, staticRenderFns } from "./edit-learningCourse.vue?vue&type=template&id=6b26adea&scoped=true&"
import script from "./edit-learningCourse.vue?vue&type=script&lang=ts&"
export * from "./edit-learningCourse.vue?vue&type=script&lang=ts&"
import style0 from "./edit-learningCourse.vue?vue&type=style&index=0&id=6b26adea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b26adea",
  null
  
)

export default component.exports